import { combineReducers } from 'redux';
import { handleActions } from 'redux-actions';

import {
    partnerRequestLoading,
    partnerRequestLoadingFailed,
    partnerRequestLoadingSucceeded,
} from '../actions/partnersActionsCreators';

const hasPartnerRequestLoading = handleActions(
    {
        [partnerRequestLoading]: () => true,
        [partnerRequestLoadingFailed]: () => false,
        [partnerRequestLoadingSucceeded]: () => false,
    },
    false,
);

const hasPartnerRequestLoaded = handleActions(
    {
        [partnerRequestLoadingSucceeded]: () => true,
    },
    false,
);

const landingPartnerRequest = combineReducers({
    hasPartnerRequestLoading,
    hasPartnerRequestLoaded,
});
export default landingPartnerRequest;

export const selectLandingPartnerRequestState = (state) =>
    state.landingPartnerRequest;
